/**
 * Secure logging utility that prevents information leakage in production
 * Only logs detailed errors in development mode
 */

interface LogContext {
  [key: string]: any;
}

class Logger {
  private isDevelopment = import.meta.env.DEV;

  error(message: string, error?: Error | unknown, context?: LogContext): void {
    if (this.isDevelopment) {
      console.error(`[Error] ${message}`, error, context);
    }
    // In production, send to monitoring service instead of logging to console
    // this.sendToMonitoring({ level: 'error', message, error, context });
  }

  warn(message: string, data?: any): void {
    if (this.isDevelopment) {
      console.warn(`[Warning] ${message}`, data);
    }
  }

  info(message: string, data?: any): void {
    if (this.isDevelopment) {
      console.info(`[Info] ${message}`, data);
    }
  }

  debug(message: string, data?: any): void {
    if (this.isDevelopment) {
      console.debug(`[Debug] ${message}`, data);
    }
  }

  // Method for logging security events (always logged to database, never to console in production)
  securityEvent(event: string, details: LogContext): void {
    if (this.isDevelopment) {
      console.warn(`[Security Event] ${event}`, details);
    }
    // Always send security events to monitoring/database
    // this.sendSecurityEvent({ event, details, timestamp: new Date() });
  }
}

export const logger = new Logger();
